import { render, staticRenderFns } from "./CalvingDetails.vue?vue&type=template&id=8fbe3aea&scoped=true&"
import script from "./CalvingDetails.vue?vue&type=script&lang=js&"
export * from "./CalvingDetails.vue?vue&type=script&lang=js&"
import style0 from "./CalvingDetails.vue?vue&type=style&index=0&id=8fbe3aea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbe3aea",
  null
  
)

export default component.exports